import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-primary p-4 text-white w-full h-full flex items-center justify-center",
  style: {"background":"linear-gradient(rgb(29, 36, 44), rgb(31, 41, 55))"}
}
const _hoisted_2 = { class: "text-4xl italic ml-5" }



interface LoadingScreenProps {
    text: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingScreen',
  props: {
    text: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "loader" }, null, -1)),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.text), 1)
  ]))
}
}

})